import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import themes from 'styles/themes';

interface listItemType {
    title: string;
    value: string;
    handleClick: (value) => {};
}

interface Props {
    listItem?: listItemType[];
}

const BottomPopupWidget = ({ listItem }: Props) => {
    const classes = useStyles();
    return (
        <div className={classes.sortWrap}>
            {listItem?.length &&
                listItem.map((option, index) => (
                    <div
                        key={option.value}
                        className={clsx(classes.option, index <= listItem.length - 2 && classes.optionBorder)}
                        onClick={() => option.handleClick(option.value)}
                    >
                        {option.title}
                    </div>
                ))}
        </div>
    );
};

export default BottomPopupWidget;

const useStyles = makeStyles(() => ({
    sortWrap: {
        marginTop: 20,
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: themes.palette.primary.main,
        padding: '10px',
        fontFamily: 'Poppins',
        fontSize: '16px',
        cursor: 'pointer',
        '&:hover': {
            background: themes.palette.secondary['500'],
            borderRadius: '4px',
        },
    },
    optionBorder: {
        borderBottom: '1px solid #D1D1D1',
    },
}));
